import { render } from "./StoryCommentBox.vue.js?vue&type=template&id=cdda8e9a!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentBox.vue?vue&type=template&id=cdda8e9a"
import script from "./StoryCommentBox.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentBox.vue?vue&type=script&lang=js"
export * from "./StoryCommentBox.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/story-comments/StoryCommentBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cdda8e9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cdda8e9a', __exports__)) {
    api.reload('cdda8e9a', __exports__)
  }
  
  module.hot.accept("./StoryCommentBox.vue.js?vue&type=template&id=cdda8e9a!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentBox.vue?vue&type=template&id=cdda8e9a", () => {
    api.rerender('cdda8e9a', render)
  })

}


export default __exports__